// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1haqF","productName":"Table_productName__23Z1_"};